import { css } from 'styled-components';
import { Device, from } from './media';
export const SitePadding = 36;
export const SiteWidth = 1520;
export const SiteWidthBreakpoint = SiteWidth + SitePadding * 2;
export const siteWide = css `
  --sitePadding: ${SitePadding}px;
  --siteWidth: ${SiteWidth}px;
  --gutterWidth: 10px;
  margin: 0 auto;
  max-width: calc(var(--siteWidth) + var(--sitePadding) + var(--sitePadding));
  padding: 0 var(--sitePadding);
  width: 100%;

  @media ${from(Device.Tablet)} {
    --gutterWidth: 16px;
  }
`;
export const baseGrid = css `
  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: repeat(12, 1fr);
`;
